import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"
import type { QueryResponse } from "./collection-statistic-query"
import { getCollectionStatisticMoleculeReatom as getCollectionStatisticMolecule } from "./get-collection-statistic-molecule.reatom"

export const useSuspendedCollectionStatitstic = (
  collectionId: CollectionId,
) => {
  const statisticMolecule = useMemo(
    () => getCollectionStatisticMolecule(collectionId),
    [collectionId],
  )
  const { suspendedStatisticQueryParams } = useMolecule(statisticMolecule)

  // Call the computed atom to get query params
  const queryParams = suspendedStatisticQueryParams()

  return useSuspenseQuery<QueryResponse>(queryParams)
}

export const useCollectionStatitstic = (collectionId: CollectionId) => {
  const statisticMolecule = useMemo(
    () => getCollectionStatisticMolecule(collectionId),
    [collectionId],
  )
  const { statisticQueryParams } = useMolecule(statisticMolecule)

  // Call the computed atom to get query params
  const queryParams = statisticQueryParams()

  return useQuery<QueryResponse>(queryParams)
}

export const useCollectionFloorPrice = (collectionId: CollectionId) => {
  const statisticMolecule = useMemo(
    () => getCollectionStatisticMolecule(collectionId),
    [collectionId],
  )
  const { statisticQueryParams } = useMolecule(statisticMolecule)

  // Call the computed atom to get query params
  const queryParams = statisticQueryParams()

  const queryResult = useQuery<QueryResponse>(queryParams)

  // Derive floor price from the query result
  return {
    ...queryResult,
    data: queryResult.data?.floor,
  }
}
